export default {
    addContactData: 'Add Contact Data',
    address: 'Address',
    cannotDeleteBecauseOnlyContact:
        'All clients must have at least one contact',
    cannotDeleteBecauseOrganization:
        'Multiple personal contacts must belong to an organization',
    cannotDeleteContact:
        'Contact may not be deleted if it is being used as the default contact',
    company: 'Company',
    defaultContact: 'Default Contact',
    deleteContact: 'Delete Contact',
    department: 'Department',
    editContact: 'Edit Contact',
    email: 'Email',
    faxNumber: 'Fax Number',
    name: 'Name',
    personal: 'Personal',
    personalTitle: 'Title',
    phoneNumber: 'Phone Number',
    setAsDefaultContact: 'Set as Default',
};
